import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/userEvents/load',
    method: 'get',
    params
  })
}


